// Styling
import './Styling/main.scss';

// Logic
import ContentService from './Services/Content.js';
import StateService from './Services/State.js';

// Rendering
import UI from './UI/UI.js';

// Variables
let error = null;
let splash = null;

let ui = null;
let timer = null;

// Functions
const showError = () => {
    error = document.createElement( 'div' );
    error.className = 'Error';
    error.innerHTML = `
        <h1 class='error-title title-l'>The application could not start</h1>
        <p class='error-text text'>Please check your network connection</p>
        <button class='button-primary' type='button' onclick='window.location.reload()'>
            Try Again
            <div class="split"></div>
        </button>
    `;
    document.body.appendChild( error );
}

const showSplash = () => {
    splash = document.createElement( 'div' );
    splash.className = 'Splash transform-in';
    splash.innerHTML = `
        <div class="image-container">
            <div class="content">
                <h1 class='splash-title title-xxs weight-regular'>Beth and Lawrence Travels</h1>
                <h2 class='splash-subtitle title-l weight-bold'>Our 6 Month Adventure</h2>
                <div class='button-container'>
                    <button class='button-primary' id='submit'>
                        Explore Our Adventure
                        <div class="split"></div>
                    </button>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild( splash );
    document.getElementById( 'submit' ).addEventListener( 'click', start );

    timer = setTimeout( () => splash.classList.remove( 'transform-in' ), 1000 );
}

const removeSplash = () => {
    if ( document.getElementById( 'submit' ) ) document.getElementById( 'submit' ).removeEventListener( 'click', start );
    if ( splash ) splash.remove();
}

const setupUI = () => {
    const element = document.createElement( 'main' );
    document.body.appendChild( element );
    ui = new UI( element );
}

const onInit = () => {
    showSplash();
}

const start = () => {
    splash.classList.add( 'transform-out' );

    timer = setTimeout( () => {
        removeSplash();
        bootup( true );
    }, 1000 );
}

// Lifecycle - Application Bootup
const bootup = async ( simple ) => {
    try {
        setupUI();
        await ContentService.onInit();

        const searchParams = new URLSearchParams( window.location.search );
        if ( !searchParams.has( 'skip' ) && ContentService.holding ) {
            ui.onHolding();
            StateService.stateHolding();
        } else {
            StateService.onInit( simple );
            ui.onReady();
            StateService.stateInitialReady();
        }
    } catch ( err ) {
        console.log( 'Error starting the application', err );
        showError();
    }
}

onInit();